import { Button, ButtonBase, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import SharepointSiteSelectModal from './SharepointSiteSelectModal';

function SharepointConnectionSettings() {
    const auth = useAuth()

    const [accessGranted, setAccessGranted] = useState(false)

    const [siteSelectModalShow, setSiteSelectModalShow] = useState(false)


  const TextButton = styled(Button)(({ theme }) => ({
    color: 'white',
    textTransform: 'none',
    padding: '0vw 0vw',
  }));

  function loginHandler() {
    const width = 600;
    const height = 700;

    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    fetch(`${window.origin}/api/dochero/auth/set-cookie`, {
      headers: {
        Authorization: `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      const popup = window.open(
        `${window.origin}/api/dochero/auth/login`,
        'oauth-popup',
        `
                width=${width},
                height=${height},
                left=${left},
                top=${top},
                resizable=yes,
                scrollbars=yes,
                status=no
                `,
      );

      if (!popup) {
        alert('Popup blocked. Please allow popups and try again.');
        return;
      }

      popup.focus();

      let intervalCheck = setInterval(() => {
        if (!accessGranted) {
          accessCheck();
        } else {
          clearInterval(intervalCheck);
        }
      }, 3000);
    }).catch((error) => {
      console.error(error);
    });
  }

  function accessCheck() {
    fetch(`${window.origin}/api/dochero/auth/access-check`, {
      headers: {
        Authorization: `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      if (response.status === 200) {
        setAccessGranted(true);
      } else {
        setAccessGranted(false);
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  useEffect(() => {
    accessCheck();
  }, []);

  return (
    <div>

            <p style={{ fontSize: '0.8vw', color: 'rgb(0, 15, 30, 0.6)', fontWeight: '300', textAlign: 'center', marginBottom: '2vw' }}>
                Configure access to your Sharepoint Site
            </p>


            <div style={{padding: '0 2.5vw'}}>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundColor: 'rgb(254, 254, 255, 0.5)',
                        padding: '1.5vw 1.5vw',
                        borderRadius: '1vw',
                        marginTop: '1.5vw',
                        marginBottom: '1.5vw' ,
                        color: 'rgb(0, 15, 30, 0.7)'
                        // border: '1px rgb(254, 254, 255, 0.07) solid'
                    }}
                >
                    <div style={{flex: 1}}>
                        <p style={{marginTop: '0', fontSize: '1.2vw', marginBottom: '0.6vw'}}>Step 1</p>
                        <p style={{fontSize: '0.85vw', margin: 0, marginBottom: '0.6vw'}}>Grant Specia access to your Microsoft Sharepoint</p>

                    </div>
                    <div style={{}}>
                        <ButtonBase disabled={accessGranted} variant='text' style={{color: 'rgb(255, 255, 255, 0.9)', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(rgb(50, 128, 128),rgb(50, 128, 128))', fontSize:'0.7vw', fontWeight: '600', cursor: 'pointer', padding: '0.5vw 1vw', backgroundColor: 'rgb(254, 254, 255, 0.05)', borderRadius: '0.4vw'}} onClick={loginHandler}>{accessGranted? 'Access Granted': 'Grant Access'}</ButtonBase>
                    </div>

                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundColor: 'rgb(254, 254, 255, 0.5)',
                        padding: '1.5vw 1.5vw',
                        borderRadius: '1vw',
                        marginTop: '1.5vw',
                        marginBottom: '1.5vw',
                        color: 'rgb(0, 15, 30, 0.7)'
                        // border: '1px rgb(254, 254, 255, 0.07) solid'
                    }}
                >
                    <div style={{flex: 1}}>
                        <p style={{marginTop: '0', fontSize: '1.2vw', marginBottom: '0.6vw'}}>Step 2</p>
                        <p style={{fontSize: '0.85vw', margin: 0, marginBottom: '0.6vw'}}>Select Sharepoint Site to perform document classification</p>

                    </div>
                    <div style={{}}>
                        <ButtonBase onClick={() => setSiteSelectModalShow(true)} variant='text' style={{color: 'rgb(255, 255, 255, 0.9)', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(rgb(50, 128, 128),rgb(50, 128, 128))', fontSize:'0.7vw', fontWeight: '600', cursor: 'pointer', padding: '0.5vw 1vw', backgroundColor: 'rgb(254, 254, 255, 0.05)', borderRadius: '0.4vw'}}>Select Site</ButtonBase>
                    </div>

                </div>
            </div>
            <SharepointSiteSelectModal show={siteSelectModalShow} onClose={() => setSiteSelectModalShow(false)}/>
        </div>
    );
}

export default SharepointConnectionSettings;
